var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.isReady),expression:"isReady"}],staticClass:"wework-frame",attrs:{"id":"weworkFrame","src":_vm.url,"width":"185","height":"205"},on:{"load":_vm.notifyPostMessage}}),(!_vm.isReady)?_c('a-spin',{staticClass:"spin-loading"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }